export const GET_PERMISSIONS = 'GET_PERMISSIONS';
export const GET_PERMISSIONS_SUCCESS = 'GET_PERMISSIONS_SUCCESS';
export const GET_PERMISSIONS_FAILED = 'GET_PERMISSIONS_FAILED';
export const EDIT_PERMISSIONS = 'EDIT_PERMISSIONS';
export const EDIT_PERMISSIONS_SUCCESS = 'EDIT_PERMISSIONS_SUCCESS';
export const EDIT_PERMISSIONS_FAILED = 'EDIT_PERMISSIONS_FAILED';
export const DELETE_PERMISSIONS = 'DELETE_PERMISSIONS';
export const DELETE_PERMISSIONS_SUCCESS = 'DELETE_PERMISSIONS_SUCCESS';
export const DELETE_PERMISSIONS_FAILED = 'DELETE_PERMISSIONS_FAILED';